import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {Observable, of} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {catchError, map, tap} from 'rxjs/operators';
import {toLoginReturnUrl} from '../utilities/helpers';


export const LoginRedirectGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean> => {
    const auth = inject(AuthService);
    return auth.loadSession().pipe(
        tap(() => {
            window.location.href = toLoginReturnUrl(route.queryParamMap.get('returnUrl'));
        }),
        map(() => false),
        catchError(() => of(true))
    );
};
